
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clients-for-life/[slug]",
      function () {
        return require("private-next-pages/clients-for-life/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clients-for-life/[slug]"])
      });
    }
  